module.exports = __webpack_public_path__ + "img/cloud-fail.1f17e9d2.svg";